import { useBrowser } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import useMeasure from 'react-use-measure';
import { ClickPadding, Container, Mask, StackContainer, } from './Activities.styles';
import Activity from './Activity';
const ActivityContainer = ({ activeStepIndex, activeChainActivity, isMobile, chainStepActivities, onImpactClaimClick, setActiveNode, onActivitySitesClick, }) => {
    const { isSafari } = useBrowser();
    // we use the active node to calculate the height of the container
    const [ref, { height: refHeight }] = useMeasure();
    // ref to prevent the animation when the step changes or the initial render
    const preventInitialAnimation = useRef(false);
    // introduce a new state to reorder the nodes when the active node changes
    const [activeActivities, setActiveActivities] = useState([]);
    // states to trigger the animation
    const [cardBringForwards, setCardBringForwards] = useState(null);
    const [cardBringBackwards, setCardBringBackwards] = useState(null);
    // state to keep track of the active step to prevent animations when the step changes
    const [stepNumber, setStepNumber] = useState(null);
    // workaround for safari to force the rerender of the component otherwise the translate values are not updated
    const [forceRerender, setForceRerender] = useState(0);
    useEffect(() => {
        // set the initial nodes on step change and prevent the animation
        const filteredActivities = chainStepActivities.filter((node) => node.id !== activeChainActivity.id);
        setActiveActivities([...filteredActivities, activeChainActivity]);
        setStepNumber(activeStepIndex);
        preventInitialAnimation.current = true;
    }, [chainStepActivities]);
    useEffect(() => {
        if (activeStepIndex !== stepNumber)
            return;
        preventInitialAnimation.current = false;
        if (!!cardBringBackwards) {
            // order for the nodes when the active node gets send backwards
            const filteredNodes = activeActivities.filter((nodeItem) => cardBringBackwards.id !== nodeItem.id);
            setTimeout(() => {
                setActiveActivities([cardBringBackwards, ...filteredNodes]);
                setCardBringBackwards(null);
            }, 420);
            return;
        }
        // order for the nodes when the active node gets send forwards
        setCardBringForwards(activeChainActivity);
        setTimeout(() => {
            setCardBringForwards(null);
            setActiveActivities((prev) => [
                ...prev.filter((node) => node.id !== (activeChainActivity === null || activeChainActivity === void 0 ? void 0 : activeChainActivity.id)),
                activeChainActivity,
            ]);
            if (isSafari) {
                preventInitialAnimation.current = true;
                setForceRerender((prev) => prev + 1);
                // Workaround for safari to force the rerender of the component otherwise the translate values are not updated
                // For some reason in safari 15 and early 16 versions transform and animation can not be used together
                setTimeout(() => (preventInitialAnimation.current = false), 500);
            }
        }, 420);
    }, [activeChainActivity]);
    if (!activeChainActivity || !chainStepActivities.length) {
        return React.createElement(React.Fragment, null, "No steps were added yet");
    }
    const openNextNode = () => {
        preventInitialAnimation.current = false;
        setCardBringBackwards(activeChainActivity);
        setActiveNode(activeActivities[activeActivities.length - 2].id);
    };
    const onNodeClick = (node) => {
        if (node.id === activeChainActivity.id) {
            return;
        }
        openNextNode();
    };
    return (React.createElement(StackContainer, { height: refHeight, minHeight: refHeight, isMobile: isMobile, numberOfActivities: chainStepActivities.length || 0 },
        activeActivities.length > 1 && React.createElement(ClickPadding, { onClick: openNextNode }),
        activeActivities.map((node) => {
            var _a;
            const isActiveNode = (activeChainActivity === null || activeChainActivity === void 0 ? void 0 : activeChainActivity.id) === node.id;
            return (React.createElement(Container, { key: node.id, ref: isActiveNode ? ref : undefined, isMobile: isMobile, isActiveNode: isActiveNode, preventAnimation: preventInitialAnimation.current, bringForward: cardBringForwards === node, bringBack: cardBringBackwards === node, numberOfNodes: chainStepActivities.length, forceRerender: forceRerender, onClick: () => onNodeClick(node) },
                !isActiveNode && (React.createElement(Mask, { opacity: ((_a = activeActivities[activeActivities.length - 2]) === null || _a === void 0 ? void 0 : _a.id) === node.id
                        ? 0.3
                        : 0.5 })),
                React.createElement(Activity, { activity: node.activity, onImpactClaimsClick: onImpactClaimClick, onActivitySitesClick: onActivitySitesClick })));
        })));
};
export default ActivityContainer;
